import React, { ReactNode } from "react";

import Stack from "veneer/Stack";

interface FormInputProps {
  children?: ReactNode;
  hasOverride?: boolean;
  inputButton?: ReactNode;
  isRequired?: boolean;
}

const FormInput = ({
  children,
  hasOverride = false,
  inputButton,
  isRequired = false,
}: FormInputProps) => {
  if (isRequired || hasOverride) {
    return <>{children}</>;
  }

  return (
    <Stack alignItems="center" direction="row" gap={1}>
      {children}
      {inputButton}
    </Stack>
  );
};

export { FormInput };
